module.exports = __webpack_public_path__ + "img/06.122d42e0.jpg";